import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Row, Col, Spin } from 'antd';
import localStorage from '../../../../../utils/localStorage';


import Marine from './images/Marine.png';
import CBM from './images/conveyor1.png';
import SL from './images/Shiploader.png';
import SLS from './images/Smart Lighting.png';
import BM from './images/Berth Monitoring.png';
import WH from './images/E-House Monitoring.png';
import WINDTURBINE from './images/Windturbine.png';

import QC from './images/QC.png';
import EOC from './images/EOC.png';
import MHC from './images/Mobile Harbour Cranes.png';
import RTG from './images/RTG.png';
import EMS from './images/EMS.png';
import GATE from './images/Gate.png';
import { StyledHomepage } from '../../../../../commons/styles/layout';

const ModulesList = (props) => {
  const userProfile = useSelector(state => state.LayoutReducer.loggedInProfile);

  const shedString = (menuKey) => {
    const imageMap = {
      'Energy Management System': EMS,
      'Gate Management System': GATE,
      'Smart Lightning System': SLS,
      'Equipment Monitoring': WH,
      'Marine Operations': Marine,
      'Mobile Harbour Cranes': MHC,
      'Equipment Operations Center': EOC,
      'Berth Monitoring System': BM,
      'Conveyor Belt Monitoring': CBM,
      'Shiploader': SL,
      'Quay Cranes': QC,
      'RTG Cranes Monitoring': RTG,
      'Wind Turbine': WINDTURBINE,
      default: 'SLD'
    };
    return imageMap[menuKey] || imageMap.default;
  };

  const onClick = (craneObject, moduleName) => {
    const moduleActions = {
      'Energy Management System': ['Modules', '1172', '1174'],
      'Gate Management System': ['Modules', '1156', '1158'],
      'Smart Lightning System': ['Modules', '1198', '1200'],
      'Marine Operations': ['Modules', '182', '184'],
      'Mobile Harbour Cranes': ['Modules', '51068', '51068'],
      'Rule Engine': ['Modules', '11173'],
      'Berth Monitoring System': ['Modules', '198', '1100'],
      'Conveyor Belt Monitoring': ['Modules', '190', '192'],
      'Shiploader': ['Modules', '176', '1188'],
      'QC Monitoring': ['Modules', '1136', '1138'],
      'RTG Cranes Monitoring': ['Modules', '1144', '1146'],
      'Wind Turbine': ['Modules', '1246', '1250'],
      'AMM': ['Modules', '11219', '11221'],
      "Quay Cranes": ['Modules', '51040', '51044']
    };

    if (moduleName && moduleActions[moduleName]) {
      // dispatch(MenuAction(moduleActions[moduleName]));
      props.layoutAction.setMenuSelection(moduleActions[moduleName]);
      props.navigate(craneObject);
    }


  };

  const site = localStorage.get('currentSite');

  if (!userProfile?.belongsTo?.sites?.[site]) {
    return (
      <div style={{ textAlign: 'center', marginTop: '30vh' }}>
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }

  const menu = userProfile.belongsTo.sites[site].role.Modules.children;

  return (
    <StyledHomepage>
      <div className='Items-list'>
        <Row gutter={16}>
          {menu && Object.keys(menu).map((menuKey) => {
            const cardName = menu[menuKey].name;
            const imageUrl = shedString(cardName);

            const hasImage = !!imageUrl;

            return cardName !== 'Equipment Overview' ? (
              <Col key={menuKey} className='columnStyle'>
                <Card
                  className="cardDesign"
                  title={cardName}
                  bordered={false}
                  onClick={() => onClick(menu[menuKey].path, cardName)}
                  style={{ borderRadius: '35px' }}
                >
                  {hasImage ? (
                    <img alt="no image" src={imageUrl} width="100%" height="250px" />
                  ) : (
                    <div className="noImageDiv">No Image Available</div>
                  )}
                </Card>
              </Col>
            ) : null;
          })}
        </Row>
      </div>
    </StyledHomepage>
  );
};

export default ModulesList;
